import { Wo1110GetResultSchema } from '@/api/production/wo1110/get.schema'
import { z } from 'zod'

export const WorkOrderPackResultsSchema = z.object({
  id: z.number(),
  shift: z.number(),
  date: z.coerce.date(),
  packQty: z.number(),
  pumpNgQty: z.number(),
  tubeNgQty: z.number(),
  excessQty: z.number(),
})

export const Prd1110GetResultSchema = WorkOrderPackResultsSchema

export type Prd1110GetResultModel = z.input<typeof Prd1110GetResultSchema>

export const Prd1110WorkOrderScheduleSchema = Wo1110GetResultSchema

export type Prd1110WorkOrderScheduleModel = z.input<
  typeof Prd1110WorkOrderScheduleSchema
>
